import { render, staticRenderFns } from "./TemplateListItem.vue?vue&type=template&id=8bc8d742&scoped=true&"
import script from "./TemplateListItem.vue?vue&type=script&lang=ts&"
export * from "./TemplateListItem.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateListItem.vue?vue&type=style&index=0&id=8bc8d742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc8d742",
  null
  
)

export default component.exports